import { render, staticRenderFns } from "./SamplingReport.vue?vue&type=template&id=66220db8"
import script from "./SamplingReport.vue?vue&type=script&lang=js"
export * from "./SamplingReport.vue?vue&type=script&lang=js"
import style0 from "./SamplingReport.vue?vue&type=style&index=0&id=66220db8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports